import { render, staticRenderFns } from "./paymentSaoma.vue?vue&type=template&id=e6c6f216&scoped=true"
import script from "./paymentSaoma.vue?vue&type=script&lang=js"
export * from "./paymentSaoma.vue?vue&type=script&lang=js"
import style0 from "./paymentSaoma.vue?vue&type=style&index=0&id=e6c6f216&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6f216",
  null
  
)

export default component.exports